import { render } from "./Assets.vue?vue&type=template&id=0a90310e&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=0a90310e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a90310e"]])

export default __exports__